if (!customElements.get('wr-klaviyo-signup-widget')) {
  const SUPPRESS_KEY = 'wr_explora_widget_suppress_until';

  class WrKlaviyoSignupWidget extends HTMLElement {
    connectedCallback() {
      this.closeBtn = this.querySelector('.wr-klaviyo-widget__close');
      this.ctaLink = this.querySelector('.wr-klaviyo-widget__cta');

      this.closeBtn?.addEventListener('click', () => this.dismiss('close'));

      if (this.dataset.trackEngagement === 'true') {
        this.ctaLink?.addEventListener('click', () => this.dismiss('cta'));
      }

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.show();
        return;
      }

      if (this.isSuppressed()) return;

      const delaySec = parseInt(this.dataset.delay || '0', 10);
      this.delayTimer = setTimeout(() => this.checkConsentAndShow(), delaySec * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.consentRetryTimer);
    }

    isSuppressed() {
      // Global suppress — set by signup section after successful completion (12 months)
      try {
        const global = window.localStorage.getItem(SUPPRESS_KEY);
        if (global && new Date(JSON.parse(global)) > new Date()) return true;
      } catch {}

      const stored = window.localStorage.getItem(this.id);
      if (!stored) return false;

      if (this.dataset.trackEngagement === 'true') {
        try {
          const { timestamp } = JSON.parse(stored);
          const days = parseInt(this.dataset.redisplayDays || '14', 10);
          const suppressUntil = new Date(timestamp);
          suppressUntil.setDate(suppressUntil.getDate() + days);
          return suppressUntil > new Date();
        } catch {
          return false;
        }
      }

      // Permanent suppress when engagement tracking is off
      return true;
    }

    checkConsentAndShow(isRetry = false) {
      if (this.dataset.requireConsent !== 'true') {
        this.show();
        return;
      }

      let consent = null;
      try {
        consent = window.Shopify?.trackingConsent?.getTrackingConsent?.() ?? null;
      } catch {}

      if (consent === 'yes') {
        this.show();
      } else if (!isRetry) {
        this.consentRetryTimer = setTimeout(() => this.checkConsentAndShow(true), 5000);
      }
    }

    show() {
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-visible');
    }

    dismiss(reason = 'close') {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');

      if (this.dataset.trackEngagement === 'true') {
        window.localStorage.setItem(
          this.id,
          JSON.stringify({ timestamp: new Date().toISOString(), reason })
        );
      } else {
        window.localStorage.setItem(this.id, JSON.stringify(new Date()));
      }
    }
  }

  customElements.define('wr-klaviyo-signup-widget', WrKlaviyoSignupWidget);
}
